import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./contexts/AuthContext";
import { I18nProvider } from "./i18n";
import { Toaster } from "sonner";

import Login from "./pages/Login";
import Register from "./pages/Register";
import AppShell from "./components/layout/AppShell";
import Chat from "./pages/Chat";
import Clients from "./pages/Clients";
import PraticheList, { PraticaDetail } from "./pages/Pratiche";
import Credits, { PaymentSuccess, PaymentCancel } from "./pages/Credits";
import Telematico from "./pages/Telematico";
import DichiarativiWorkspace from "./pages/Dichiarativi";
import { AdminStats, AdminAffiliates, AdminPayments } from "./pages/Admin";

function RequireAdmin({ children }) {
    const { user } = useAuth();
    if (user?.role !== "super_admin") return <Navigate to="/chat" replace />;
    return children;
}

export default function App() {
    return (
        <I18nProvider>
            <AuthProvider>
                <Toaster position="top-center" />
                <BrowserRouter>
                    <Routes>
                        <Route path="/login" element={<Login />} />
                        <Route path="/register" element={<Register />} />
                        <Route path="/payment/success" element={<PaymentSuccess />} />
                        <Route path="/payment/cancel" element={<PaymentCancel />} />

                        <Route element={<AppShell />}>
                            <Route path="/" element={<Navigate to="/chat" replace />} />
                            <Route path="/chat" element={<Chat />} />
                            <Route path="/clients" element={<Clients />} />
                            <Route path="/pratiche" element={<PraticheList />} />
                            <Route path="/pratiche/:id" element={<PraticaDetail />} />
                            <Route path="/credits" element={<Credits />} />
                            <Route path="/telematico" element={<Telematico />} />
                            <Route path="/moduli/:moduleCode" element={<DichiarativiWorkspace />} />
                            <Route path="/admin/stats" element={<RequireAdmin><AdminStats /></RequireAdmin>} />
                            <Route path="/admin/affiliates" element={<RequireAdmin><AdminAffiliates /></RequireAdmin>} />
                            <Route path="/admin/payments/provider" element={<RequireAdmin><AdminPayments view="provider" /></RequireAdmin>} />
                            <Route path="/admin/payments/accrediti" element={<RequireAdmin><AdminPayments view="accrediti" /></RequireAdmin>} />
                            <Route path="/admin/payments/crediti-generali" element={<RequireAdmin><AdminPayments view="crediti-generali" /></RequireAdmin>} />
                            <Route path="/admin/payments/tariffario" element={<RequireAdmin><AdminPayments view="tariffario" /></RequireAdmin>} />
                        </Route>

                        <Route path="*" element={<Navigate to="/chat" replace />} />
                    </Routes>
                </BrowserRouter>
            </AuthProvider>
        </I18nProvider>
    );
}
